export default "__VITE_ASSET__BE7VRJln__"